import { type Span, trace } from "@opentelemetry/api";
import React from "react";
import { useLocation, useNavigationType } from "react-router";

const tracer = trace.getTracer("customer-portal-ui");

export function useRouteTracing() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const spanRef = React.useRef<Span | null>(null);
  const startTimeRef = React.useRef<number>(Date.now());

  React.useEffect(() => {
    if (spanRef.current) {
      const duration = Date.now() - startTimeRef.current;
      spanRef.current.setAttribute("route.duration_ms", duration);
      spanRef.current.end();
    }

    startTimeRef.current = Date.now();
    spanRef.current = tracer.startSpan("route.render", {
      attributes: {
        "route.path": location.pathname,
        "route.search": location.search,
        "route.hash": location.hash,
        "navigation.type": navigationType,
      },
    });

    return () => {
      if (spanRef.current) {
        spanRef.current.end();
      }
    };
  }, [location.pathname, location.search, location.hash, navigationType]);
}
